// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "lolia-acessorios.firebaseapp.com",
  "projectId": "lolia-acessorios",
  "storageBucket": "lolia-acessorios.appspot.com",
  "messagingSenderId": "551840032799",
  "appId": "1:551840032799:web:a0adb705650f01d2a34d2a",
  "measurementId": "G-Y1RF5Q3CJE",
  "apiKey": "AIzaSyAPBYLXK-MhMucNstGK9EE_fKxh87cT8Rg"
};
